import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';
import { useDispatch } from 'react-redux';

function useTranslateText() {
  const dispatch = useDispatch();
  const translateString = async (data) => {
    try {
      const response = await AxiosConfig.create('post', '/translate/text')
        .call(data)
        .getResponseData();
      if (response?.status > 300) {
        const messageError = `Error: ${response?.status} - ${response?.message}: Translate Text`;
        dispatch(
          setSnackBar({ open: true, message: messageError, color: 'error' })
        );
      } else {
        dispatch(setSnackBar({ open: false, message: null, color: null }));
      }
      return {
        translatedString: response?.data,
        res: {
          status: response?.code,
          statusText: response?.message,
        },
      };
    } catch (error) {
      const messageError = `Error: ${error}: Translate Text`;
      dispatch(
        setSnackBar({ open: true, message: messageError, color: 'error' })
      );
    }
  };
  return {
    translateString,
  };
}

export default useTranslateText;
